import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQr = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M15 9v6H9V9zm3-3H6v12h12z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.5 10.5h-3v3h3zM39 9v6h-6V9zm3-3H30v12h12z" }),
		/* @__PURE__ */ _jsx("path", { d: "M37.5 10.5h-3v3h3zM15 33v6H9v-6zm3-3H6v12h12z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.5 34.5h-3v3h3zM6 24h12v3H6zm18-12h3v3h-3zm0-3h3v3h-3zm0-3h3v3h-3zm-3 9h3v3h-3zm3 6h3v3h-3zm0 6h3v12h-3zm9 0h3v15h-3zm-15-6h3v3h-3zm3 3h3v3h-3zm0 9.75h3v3h-3zM33 21h3v3h-3zm-6 6h3v3h-3zm9-3h3v3h-3zm0 9h3v3h-3zm0 6h3v3h-3zm3-12h3v3h-3zm0 6h3v3h-3zm-9 3h3v3h-3z" })
	] }) })
});
export default SvgQr;
